import React from 'react';
import AdminMenuGrid from '../components/AdminMenuGrid';
import {
  Wallet, PiggyBank, Share2, Receipt, Shuffle, Building, RotateCcw, KeyRound
} from 'lucide-react';

const ProductsHubPage = () => {
  const items = [
    { label: 'Loan Products', icon: Wallet, path: '/dashboard/admin/products/loan-products', id: 'loan-products' },
    { label: 'Savings Products', icon: PiggyBank, path: '/dashboard/admin/products/savings-products', id: 'savings-products' },
    { label: 'Share Products', icon: Share2, path: '/dashboard/admin/products/share-products', id: 'share-products' },
    { label: 'Lease Products', icon: KeyRound, path: '/dashboard/admin/products/lease-products', id: 'lease-products' },
    { label: 'Charges', icon: Receipt, path: '/dashboard/admin/products/charges', id: 'charges' },
    { label: 'Product Mix', icon: Shuffle, path: '/dashboard/admin/products/product-mix', id: 'product-mix' },
    { label: 'Fixed Deposit Products', icon: Building, path: '/dashboard/admin/products/fixed-deposits', id: 'fixed-deposits' },
    { label: 'Recurring Deposit Products', icon: RotateCcw, path: '/dashboard/admin/products/recurring-deposits', id: 'recurring-deposits' },
  ];

  return <AdminMenuGrid title="Products" breadcrumb={['Products', 'Home / Products']} items={items} />;
};

export default ProductsHubPage;
